<template>
  <section v-observe-visibility="isVisible" :class="$style.heroContainer">
    <Wrapper>
      <Breadcrumb excluded-path="release" :custom-name="title[0].text" />
      <Title :title-params="title" is-mega-title :class="$style.title" />
    </Wrapper>
  </section>
</template>

<script>
import Breadcrumb from '~/components/Breadcrumb'
import Title from '~/components/Title'

export default {
  components: {
    Breadcrumb,
    Title,
  },

  props: {
    title: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isVisible(visible) {
      this.$store.commit('header/SET_HEADER_FIXED', !visible)
    },
  },
}
</script>

<style lang="scss" module>
.heroContainer {
  margin-top: -64px;
  padding: 104px 24px 80px;

  background-color: #fff4ee;
}

.title {
  margin-top: 16px;

  font-weight: 200;
}
</style>
